import {
  createSearchParams,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom'
import { useContext } from 'react'
import { NavContext } from '../../../../../context/global_context'
import ConnectorPinsSection from '../../../../../antd/dtcs/TATMappings/ConnectorMapping/ConnectorPinsSection'
import ConnectorPinsStore from '../../../../../antd/dtcs/TATMappings/ConnectorMapping/context/context'
import SelectConnectorSection from '../../../../../antd/dtcs/TATMappings/ConnectorMapping/SelectConnectorSection'
import { Flex, Row, Typography } from 'antd'
import DTCMappingSection from '../../../../../antd/dtcs/TATMappings/ConnectorMapping/DTCMappingSection'
import EditDtcsMappingHeader from '../../../../../antd/dtcs/TATMappings/EditDtcsMappingHeader'

const TatConnectorMapping = () => {
  let { vehicle, connector_id } = useParams()
  const navigate = useNavigate()
  const [value] = useContext(NavContext)
  const [searchParams, setSearchParams] = useSearchParams()

  return (
    <ConnectorPinsStore>
      <div className="page edit-dtc-mappings">
        <Row className="title">
          <Flex vertical gap={16} style={{ width: '100%' }}>
            {value?.dtc_details?.length > 0 && (
              <>
                <Typography.Title level={5}>
                  {value?.dtc_details?.length} DTCs Selected
                </Typography.Title>

                <EditDtcsMappingHeader
                  dtcs={value?.dtc_details}
                  vehicleSid={value?.vehicle}
                />
              </>
            )}
          </Flex>
        </Row>
        <Row className="body">
          <Flex
            align="flex-start"
            justify="space-evenly"
            className="col-container"
          >
            <ConnectorPinsSection destinationOnly={value?.destination_only} hasSelectedDtc={value?.dtc_details?.length > 0} />
            
            <Flex className="col" gap={16}>
              <SelectConnectorSection />
            </Flex>
            
            <DTCMappingSection />
          </Flex>
        </Row>
      </div>
    </ConnectorPinsStore>
  )
}

export default TatConnectorMapping
